<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Mitarbeiter löschen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text>
          Sie möchten den Mitarbeiter <b>{{user.firstName}} {{user.lastName}} ({{user.email}})</b> wirklich löschen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="deleteUser"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteUserConfirmDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object,
        default: function () {
          return {
            id: 0,
            email: '',
            firstName: '',
            lastName: ''
          }
        }
      }
    },
    methods: {
      deleteUser () {
        this.$store.dispatch('deleteUser', this.user.id)
          .finally(() => this.$emit('close'))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/DeleteUserConfirmDialog.vue